module.exports = __webpack_public_path__ + "media/images/connected-2-3bdbce0ac80f89530f04179572c765ff.jpg";